<wcg-dialog title="Session Time Out">
  <div content>
    <p>Your session has expired and you will be logged out.</p>
  </div>
  <div primary data-testid="primary-button-container">
    <wcg-button
      wcg-button
      mat-flat-button
      color="primary"
      data-testid="logout-button"
      (click)="logout()"
    >
      Logout
    </wcg-button>
  </div>
</wcg-dialog>
